import React, { useState, useEffect, useContext } from 'react'
import { AuthContext } from "../contexts/AuthContext";
import { CFormInput, CTable, CTableDataCell, CTableHeaderCell, CTableBody, CTableRow, CTableHead, CModal, CModalHeader, CModalBody, CButton, CTooltip } from '@coreui/react'
import axios from 'axios'
import ReactLoading from 'react-loading';
import './Bebidas.css'
import { TableVirtuoso } from 'react-virtuoso';
import dayjs from 'dayjs'

function EntregaBeneficios() {
  let { user1 } = useContext(AuthContext);
  let [loading, setLoading] = useState(true)
  let [beneficiosOG, setBeneficiosOG] = useState([])
  let [beneficios, setBeneficios] = useState([])

  const excludeColumns = ["_id", "is_active", "createdAt", "updatedAt"]; // excluye datos del arreglo donde se buscara

  function getBebidas() {
    if (user1.role == 'restaurant') {
      axios.get(`${process.env.REACT_APP_BackURL}/getRestaurantHistoryByRestaurantID?restaurantID=${user1.id}`)
        .then((response) => { setBeneficios(response.data.data); setBeneficiosOG(response.data.data); setLoading(false) })
        .catch((err) => { console.log(err) })
    }
  }

  // handle change event of search input
  function handleChange(value) {
    filterData(value);
  };

  // filter records by search text
  function filterData(value) {
    const searchTerms = value.toLowerCase().trim().split(/\s+/); // Divide por espacios
    if (searchTerms.length === 1 && searchTerms[0] === "") {
      setBeneficios(beneficiosOG);
      return;
    }

    const filteredData = beneficiosOG.filter((item) => {
      // Verifica cada término de búsqueda en los campos no excluidos
      return searchTerms.every(term => {
        return Object.keys(item).some((key) => {
          if (excludeColumns.includes(key)) return false;
          return item[key].toString().toLowerCase().includes(term);
        });
      });
    });

    setBeneficios(filteredData);
  };

  function actualizarBeneficio(id, status, delivered) {
    axios.patch(`${process.env.REACT_APP_BackURL}/updateRestaurantHistoryById?id=${id}`, { status: status, delivered: delivered })
      .then((response) => { getBebidas() })
      .catch((err) => { console.log(err) })
  }

  useEffect(() => {
    if (user1?.id) {
      getBebidas();
    }
  }, [user1]);

  return (
    <>
      <div className='centro'>

        {/* <center>
          <CFormInput style={{ "width": "30%" }} type="text" id="floatingInput" label="Buscador" placeholder='Buscar' onChange={((e) => { handleChange(e.target.value) })} />
        </center> */}

        <br />

        <div style={{ textAlign: 'center' }}>

          <h5>{beneficios.length} beneficios</h5>

        </div>

        <br />

        {
          !loading ?
            beneficios.length == 0 ?
              <div style={{ textAlign: 'center' }}><h1>No hay beneficios registrados</h1></div>
              :
              <>
                <TableVirtuoso
                  style={{ height: "55vh", width: '100%' }}
                  data={beneficios}
                  components={{
                    Table: ({ style, ...props }) => <CTable {...props} style={{ backgroundColor: "rgb(82,93,113)" }} color="dark" hover />,
                    TableHead: CTableHead,
                    TableRow: CTableRow,
                    TableBody: CTableBody
                  }}

                  fixedHeaderContent={() => (
                    <CTableRow color='info'>
                      <CTableHeaderCell className='cells'>Fecha</CTableHeaderCell>
                      <CTableHeaderCell className='cells'>Cliente</CTableHeaderCell>
                      <CTableHeaderCell className='cells'>Precio</CTableHeaderCell>
                      <CTableHeaderCell className='cells'>Tipo</CTableHeaderCell>
                      <CTableHeaderCell className='cells'>Estatus</CTableHeaderCell>
                      <CTableHeaderCell className='cells'>Acciones</CTableHeaderCell>
                    </CTableRow>
                  )}

                  itemContent={(index, item) => {
                    return (
                      <>
                        <CTableDataCell color={item.status == 'Pendiente' ? 'warning' : item.status == 'Entregado' ? 'success' : 'danger'} className='cells'>{dayjs(item.date).format('DD/MM/YYYY')}</CTableDataCell>
                        <CTableDataCell color={item.status == 'Pendiente' ? 'warning' : item.status == 'Entregado' ? 'success' : 'danger'} className='cells'>{item.userID?.name.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CTableDataCell>
                        <CTableDataCell color={item.status == 'Pendiente' ? 'warning' : item.status == 'Entregado' ? 'success' : 'danger'} className='cells'>{item.drinkID.price}</CTableDataCell>
                        <CTableDataCell color={item.status == 'Pendiente' ? 'warning' : item.status == 'Entregado' ? 'success' : 'danger'} className='cells'>{item.drinkID.type.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CTableDataCell>
                        <CTableDataCell color={item.status == 'Pendiente' ? 'warning' : item.status == 'Entregado' ? 'success' : 'danger'} className='cells'>{item.status.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase())}</CTableDataCell>
                        <CTableDataCell color={item.status == 'Pendiente' ? 'warning' : item.status == 'Entregado' ? 'success' : 'danger'} style={{ display: "flex", gap: '10px' }}>
                          <CTooltip content="Entregar">
                            <CButton disabled={item.status == 'Entregado'} color='success' onClick={() => { actualizarBeneficio(item._id, "Entregado", true) }}>
                              <i className="fa-solid fa-check"></i>
                            </CButton>
                          </CTooltip>
                          <CTooltip content="Cancelar">
                            <CButton disabled={item.status != 'Pendiente'} color='danger' onClick={() => { actualizarBeneficio(item._id, "Cancelado", false) }}>
                              <i className="fa-solid fa-xmark"></i>
                            </CButton>
                          </CTooltip>
                        </CTableDataCell>

                      </>
                    )
                  }}
                />
              </>
            : <><div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div></>
        }

        <br />

      </div>
    </>
  )
}

export default EntregaBeneficios
